import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Spinner } from 'reactstrap'

import { WEBSITE_URL } from 'resources/constants'
import { STRING, EVENT_TYPE } from 'resources'
import { sendAnalyticsEvent } from 'services/analytics'
import authActions from 'models/Authentication/actions'

const SIGN_OUT_MESSAGE_TIMEOUT = 5000

const SignOut = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const unauthorizedAccountSignOutRedirect = useMemo(
    () => !!location.state?.unauthorizedAccountSignOutRedirect,
    [location],
  )
  useEffect(() => {
    if (unauthorizedAccountSignOutRedirect) {
      sendAnalyticsEvent(EVENT_TYPE.unauthorizedAccountSignOutRedirect)
    }
    dispatch(
      authActions.signOutUser.init((isSuccess) => {
        setTimeout(() => window.location.assign(WEBSITE_URL), SIGN_OUT_MESSAGE_TIMEOUT)
        if (isSuccess) {
          sendAnalyticsEvent(EVENT_TYPE.accountSignOut)
        }
      }),
    )
  }, [dispatch, unauthorizedAccountSignOutRedirect])

  return (
    <div className="align-items-center text-center mt-5 pt-5 mx-3">
      <Spinner />
      <h1 className="pt-2">{STRING.signOut.title}</h1>
      <h5 className="pt-2">{STRING.signOut.message}</h5>
    </div>
  )
}

export default SignOut
